import { Pipe, PipeTransform } from '@angular/core';
import { VendorManagerService } from 'src/app/vendor-management/services/vendor-manager.service';
import { SystemInstance } from '../models/systems.interface';

/** Inventory "Usage / business impact" column label — same score→label mapping the system page uses. */
@Pipe({
    standalone: true,
    name: 'systemUsageLabel'
})
export class SystemUsageLabelPipe implements PipeTransform {

    constructor(private vendorManagerService: VendorManagerService) {}

    transform(system: SystemInstance): string {
        const usage = system?.systemUsage;
        const score = usage?.manuallySet ? usage.score : usage?.discoveryScore;
        return this.vendorManagerService.getScoreDropdownValue(score)?.value ?? '';
    }
}
